import React from "react";
import { Input } from "@heroui/react";

export function PortalTextField({ label, value, onChange, type = "text", readOnly = false, placeholder }) {
  return (
    <label className="portal-field">
      <span className="portal-field__label">{label}</span>
      <Input
        className="w-full"
        fullWidth
        variant="secondary"
        type={type}
        value={value ?? ""}
        readOnly={readOnly}
        placeholder={placeholder}
        onChange={(event) => onChange?.(event.target.value)}
      />
    </label>
  );
}
